export default __webpack_public_path__ + "static/media/icon_header_share_24_Regular.2d6c2ed0.svg";